exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-input-wrap{width:100%;height:44px;background-color:#f5f5f5;position:fixed;z-index:999;top:0}.search-input-wrap .search-input{margin:6px 12px;width:calc(100% - 24px);outline:none;border:none;height:32px;border-radius:5px;text-align:center;font-size:14px;-webkit-appearance:none}@media only screen and (min-width:600px){.search-input-wrap{width:598px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/SearchWrap.scss
// module id = 615
// module chunks = 0